module.exports = __webpack_public_path__ + "static/img/t37.cdd08743.png";